import { Injectable } from '@angular/core';
import { Subject } from "rxjs";

/*
 * This Events service replaces the Ionic Angular 4 Events service and uses RxJS for the same API
 *
 * Basically, it copies the API that the Ionic Angular 4 Events service implemented, to make it plug-and-play.
 * However, it uses RxJS observables to do the actual event listening and routing
 */
@Injectable({
    providedIn: 'root'
})
export class Events {

    eventSubject: any = {};

    constructor(
    ) {
    }

    addNewEventIfNecessary(eventName: string) {
        if (this.eventSubject[eventName]) {
            return;
        }
        this.eventSubject[eventName] = new Subject();
    }

    subscribe(eventName: string, callback: (any) => any) {
        this.addNewEventIfNecessary(eventName);
        this.eventSubject[eventName].subscribe({ next: callback });
    }

    unsubscribe(eventName: string, param: any = null) {
        if(!this.eventSubject || !this.eventSubject.hasOwnProperty(eventName)) {
            console.log('Unable to unsubscribe from: ', eventName);
            return;
        }
        this.eventSubject[eventName].complete();
        delete this.eventSubject[eventName];
    }

    getSubject(eventName: string) {
        this.addNewEventIfNecessary(eventName);
        return this.eventSubject[eventName];
    }

    publish(eventName: string, param: any = null) {
        this.addNewEventIfNecessary(eventName);
        if (param !== null) {
            this.eventSubject[eventName].next(param);
        } else {
            this.eventSubject[eventName].next();
        }
    }

    hasSubscriptions(eventName: string) {
        return !!this.eventSubject[eventName];
    }
}
